import { createApp } from 'vue'
import { createStore } from 'vuex'
import axios from "axios";
import AppMain from './AppMain.vue'
import i18n, { getSavedLanguage, setLanguage } from './i18n';

// 1. Налаштовуємо axios interceptor для заголовків
axios.interceptors.request.use((config) => {
  const lang = getSavedLanguage();
  config.headers['Accept-Language'] = lang;
  return config;
});

// Допоміжна функція: рекурсивно або пофокусно замінює {lang} в усіх рядках об'єкта/масиву
function replaceLangPlaceholder(data, lang) {
  if (!data) return data;

  if (typeof data === 'string') {
    return data.replaceAll('{lang}', lang);
  }

  if (Array.isArray(data)) {
    return data.map(item => replaceLangPlaceholder(item, lang));
  }

  if (typeof data === 'object') {
    const processed = {};
    for (const key in data) {
      processed[key] = replaceLangPlaceholder(data[key], lang);
    }
    return processed;
  }

  return data;
}

// 2. Vuex Store
const store = createStore({
  state: {
    raw: [],
    info: [],
    navLinks: [],
    socicons: [],
    spinner: true,
    isFirstLoad: true, // Початковий прапор
  },
  actions: {
    GetData: ({ commit }, lang) => {
      commit('SetSpinner', true);
      const currentLang = lang || getSavedLanguage();

      // let back_url = 'http://127.0.0.1:8000';
      let back_url = 'https://fotka.kiev.ua';

      return axios.get(`${back_url}/${currentLang}/cv/api/alldata/`)
        .then(response => {
          commit('GetInfo', { infos: response.data, lang: currentLang });
        })
        .catch(error => {
          console.error("Помилка завантаження даних:", error);
          commit('SetSpinner', false);
        });
    },

    ChangeLanguage: async ({ dispatch }, newLang) => {
      setLanguage(newLang);
      await dispatch('GetData', newLang);
    }
  },
  mutations: {
    GetInfo: (state, payload) => {
      const { infos, lang } = payload;

      if (infos && infos.length > 0) {
        // Універсально замінюємо {lang} на поточну мову (uk/en/...) у ВСІХ полях та масивах відповіді
        const cleanData = replaceLangPlaceholder(infos[0], lang);

        state.raw = cleanData;

        const navSet = cleanData.navigations_set || [];
        state.navLinks = navSet.filter(x => x.variant !== "icons");
        state.socicons = navSet.filter(x => x.variant === "icons");
      }
      state.spinner = false;
    },
    SetSpinner: (state, status) => {
      state.spinner = status;
    },
    DisableFirstLoad: (state) => {
      state.isFirstLoad = false;
    }
  },
});

// 3. Ініціалізація додатку
const app = createApp(AppMain);

app.use(store);
app.use(i18n);

const initialLang = getSavedLanguage();
store.dispatch('GetData', initialLang);

app.mount('#app');